import $http from '../../shared/http';

export const statuses = {
  namespaced: true,
  state: () => {
    return {
      statusesForSelect: null,
    };
  },
  getters: {
    getStatusesForSelect: (state) => (currentLanguage) => {
      const membershipStatuses = state?.statusesForSelect ?? [];
      if (!currentLanguage || !membershipStatuses.length) {
        return [];
      }

      return (
        membershipStatuses
          ?.map((membershipStatus) => ({
            value: membershipStatus.value,
            text: membershipStatus.localisations?.[currentLanguage]?.name || membershipStatus.text,
          }))
          ?.sort((a, b) => a.text.toUpperCase().localeCompare(b.text.toUpperCase())) ?? []
      );
    },

    getExistingStatusNames: (state) => state.existingStatusNames,
  },
  mutations: {
    setStatusesForSelect: (state, payload) => (state.statusesForSelect = payload),
    setExistingStatusNames: (state, payload) => (state.existingStatusNames = payload),
  },
  actions: {
    async LOAD_STATUSES_FOR_SELECT({ commit }, payload = {}) {
      const { churchId } = payload;
      return $http('v2')
        .get(churchId ? `organisations/${churchId}/membership_statuses` : 'membership_statuses')
        .then((response) => {
          commit('setStatusesForSelect', response.data.data);
          return response;
        });
    },

    async getStatusNamesAction({ commit }) {
      commit('setExistingStatusNames', null);
      return $http()
        .get('/statuses/check/names')
        .then((response) => {
          commit('setExistingStatusNames', response.data.data);
          return response;
        });
    },
  },
};
